import React from "react";
import DialogLayout from "./DialogLayout";
import { BrandContent } from "./shared";

interface Props {
    open: boolean;
    title: string;
    message: React.ReactNode;
    /** Libellé du seul bouton disponible (action correctrice). */
    actionLabel: string;
    /** Fermeture du popup : l'utilisateur retourne corriger sa saisie. */
    onAction: () => void;
}

/**
 * P1 – Popup bloquant réglementaire : pas de bouton d'annulation ni de
 * contournement, la seule issue est l'action correctrice (compléter les
 * séances, renseigner la description…). Réutilisé en P4.
 */
const BlockingPopup = ({ open, title, message, actionLabel, onAction }: Props) => {
    return (
        <DialogLayout
            title={title}
            text={
                <BrandContent
                    tag="div"
                    children={<>{message}</>}
                    type="description"
                    className="space-y-2"
                />
            }
            open={open}
            valid={actionLabel}
            handleSubmit={onAction}
            handleClose={onAction}
            handleCloseIcon={onAction}
        />
    );
};

export default BlockingPopup;
